var _path, _path2, _path3, _path4, _ellipse, _g, _path5, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactNativeGoogleMobileAdsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 340 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "google-mobile-ads-bg_svg__a",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-mobile-ads-bg_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-mobile-ads-bg_svg__b)",
    d: "M0 0h340v328H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-mobile-ads-bg_svg__c)",
    d: "M0 0h340v328H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "google-mobile-ads-bg_svg__d",
    width: 246,
    height: 294,
    x: -106,
    y: -30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.868,
    cy: 116.934,
    fill: "#D9D9D9",
    rx: 119,
    ry: 149.561,
    transform: "rotate(19.57 16.868 116.934)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-mobile-ads-bg_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.995,
    cy: 245.995,
    r: 245.995,
    stroke: "url(#google-mobile-ads-bg_svg__f)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 270.991 -255)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229.865,
    cy: 229.865,
    r: 229.865,
    stroke: "url(#google-mobile-ads-bg_svg__h)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 254.866 -238.871)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.734,
    cy: 213.734,
    r: 213.734,
    stroke: "url(#google-mobile-ads-bg_svg__j)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 238.733 -222.738)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197.603,
    cy: 197.603,
    r: 197.603,
    stroke: "url(#google-mobile-ads-bg_svg__l)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 222.6 -206.611)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.472,
    cy: 181.472,
    r: 181.472,
    stroke: "url(#google-mobile-ads-bg_svg__n)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 206.475 -190.477)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__o)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165.341,
    cy: 165.341,
    r: 165.341,
    stroke: "url(#google-mobile-ads-bg_svg__p)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 190.346 -174.348)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__q)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 149.21,
    cy: 149.21,
    r: 149.21,
    stroke: "url(#google-mobile-ads-bg_svg__r)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 174.213 -158.217)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__s)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.08,
    cy: 133.08,
    r: 133.08,
    stroke: "url(#google-mobile-ads-bg_svg__t)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 158.079 -142.086)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__u)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.949,
    cy: 116.949,
    r: 116.949,
    stroke: "url(#google-mobile-ads-bg_svg__v)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 141.95 -125.953)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__w)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100.818,
    cy: 100.818,
    r: 100.818,
    stroke: "url(#google-mobile-ads-bg_svg__x)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges",
    transform: "matrix(-1 0 0 1 125.817 -109.821)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "google-mobile-ads-bg_svg__z",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-mobile-ads-bg_svg__y)",
    d: "M0 0h340v328H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-mobile-ads-bg_svg__z)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__A)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.456,
    cy: 65.207,
    fill: "#7F8AAD",
    rx: 35.456,
    ry: 65.207,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 396.867 247.562)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__B)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 30.412,
    fill: "#8F99B7",
    rx: 25.305,
    ry: 30.412,
    transform: "matrix(-1 0 -.0645 -.99792 369.533 264.637)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-mobile-ads-bg_svg__C)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 30.412,
    fill: "#B4BBCF",
    rx: 25.305,
    ry: 30.412,
    transform: "matrix(-1 0 -.0645 -.99792 369.531 264.637)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__e",
    width: 493.491,
    height: 494.991,
    x: -221.75,
    y: -255.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__g",
    width: 461.229,
    height: 462.729,
    x: -205.613,
    y: -239.621,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__i",
    width: 428.968,
    height: 430.468,
    x: -189.484,
    y: -223.488,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__k",
    width: 396.706,
    height: 398.206,
    x: -173.356,
    y: -207.361,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__m",
    width: 364.444,
    height: 365.944,
    x: -157.219,
    y: -191.227,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__o",
    width: 332.182,
    height: 333.682,
    x: -141.086,
    y: -175.098,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__q",
    width: 299.921,
    height: 301.421,
    x: -124.958,
    y: -158.967,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__s",
    width: 267.659,
    height: 269.159,
    x: -108.83,
    y: -142.836,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__u",
    width: 235.397,
    height: 236.897,
    x: -92.697,
    y: -126.703,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__w",
    width: 203.135,
    height: 204.636,
    x: -76.569,
    y: -110.571,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__A",
    width: 190.306,
    height: 215.005,
    x: 236.779,
    y: 101.187,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2051",
    stdDeviation: 24.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__B",
    width: 138.764,
    height: 148.697,
    x: 272.884,
    y: 159.939,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2051",
    stdDeviation: 22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-mobile-ads-bg_svg__C",
    width: 138.764,
    height: 148.697,
    x: 272.883,
    y: 159.939,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2051",
    stdDeviation: 22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__f",
    x1: 113.035,
    x2: -26.045,
    y1: 446.084,
    y2: 327.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__h",
    x1: 103.375,
    x2: 32.376,
    y1: 422.371,
    y2: 364.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__j",
    x1: 122.242,
    x2: 6.242,
    y1: 404.738,
    y2: 313.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__l",
    x1: 90.799,
    x2: 11.609,
    y1: 358.33,
    y2: 278.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__n",
    x1: 83.387,
    x2: -19.213,
    y1: 329.078,
    y2: 241.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__p",
    x1: 75.975,
    x2: -9.645,
    y1: 299.827,
    y2: 237.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__r",
    x1: 68.562,
    x2: -3.778,
    y1: 270.576,
    y2: 210.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__t",
    x1: 61.15,
    x2: -14.09,
    y1: 241.324,
    y2: 177.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__v",
    x1: 53.738,
    x2: -6.541,
    y1: 212.073,
    y2: 168.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-mobile-ads-bg_svg__x",
    x1: 46.326,
    x2: -0.174,
    y1: 182.821,
    y2: 146.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "google-mobile-ads-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(127.49973 185.99966 -132.53994 90.85396 0 115.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#634C47",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#402924",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "google-mobile-ads-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.868 188.84 69.29)scale(174.751 258.474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#373B4A",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "google-mobile-ads-bg_svg__y",
    width: 0.353,
    height: 0.366,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-mobile-ads-bg_svg__D",
    transform: "scale(.00294 .00305)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL0SURBVHgB7drBkYRADEPRzT8DciKn3giGklBzkPu/EzXFzuLDqIzbf3+Yb611/7i+fny+ftyzhOvb/L/ud17C9xxVL4BqD1FwCddu7LiR5UbuJdRyVL0AqoVd6BV8jxtrSoepRPFR9QKo9iIWknhMOtslPHMyxBhZL4BqS3uRV67dztMdMiixdgf3j6wXQLWlvbwncaFEnPsMd/C3R9ULoJrYxSWDBSVS3CjbFYPj6wVQ7UX36B7DuQtsbky5UXxUvQCqiR2ju7GQdJLuhkMSfePrBVBNjIXkKC1ZfnO7Yjeux9cLoJoYTUlH6kaiEmtuN5vMlqvrBVBNjIUtR1fi57vmvUrMjq8XQLWHTk85Mvt69vt1Fz2+XgDVXnSDu47P3KjcNUA4ql4A1R5+8knn6cbdMu93Y80daIypF0C1Zb44h5HodrC7ulZlI2JkvQCqrWyrIbnHjVBlPuzOe8fXC6Dai59/slf8RbTuOv4bWS+Aahtjyh0m7BpKKM//RSxX1Aug2sYuUXnxd+e0bsQl2x0j6wVQTYyI5JhMiTU34pJtiqPqBVBN7PSSo7ckstzIdTvP8fUCqBZ2ocrcNXlhV4YSbhQfVS+Aai9iIYnHpLN158zJUeCYegFUW9qLvHKdbEoke8LJJsb4egFUW/6SmBsXSsS5z3AHf3tUvQCqiV1cMlhQIsWNsl0xOL5eANVedI/uMZy7wObGlBvFR9ULoJrYMbobC0kn6W44JNE3vl4A1cRYSI7SkuU3tyt243p8vQCqidGUdKRuJCqx5nazyWy5ul4A1cRY2HJ0JX6+a96rxOz4egFUe+j0lCOzr2e/X3fR4+sFUO1FN7jr+MyNyl0DhKPqBVDt4SefdJ5u3C3zfjfW3IHGmHoBVFvmi3MYiW4Hu6trVTYiRtYLoNrKthqSe9wIVebD7rx3fL0Aqr34+Sd7xV9E667jv5H1Aqi2MabcYcKuoYTy/F/EckW9AKpt7BKVF393TutGXLLdMbJeDPYPkN6qZhcPlQEAAAAASUVORK5CYII=",
    id: "google-mobile-ads-bg_svg__D",
    width: 120,
    height: 120
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNativeGoogleMobileAdsBg);
export default __webpack_public_path__ + "static/media/react-native-google-mobile-ads-bg.01744d36f370c737f697ace152b1bac7.svg";
export { ForwardRef as ReactComponent };